<template>
  <div class="container">
    <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>

    <h1 v-if="language.includes('es')">Categorías</h1>
    <h1 v-else>Categories</h1>

    <!-- Botones para seleccionar categoría a mostrar -->
    <div v-if="language.includes('es')">
      <button @click="elegirCategoria('niños')" class="buttonCategorias" :style="[mostrarCategoria === 'niños' ? { 'background-color': '#25274F' } : '']"> Niños </button>
      <button @click="elegirCategoria('adultos')" class="buttonCategorias" :style="[mostrarCategoria === 'adultos' ? { 'background-color': '#25274F' } : '']"> Adultos </button>
      <button @click="elegirCategoria('abuelos')" class="buttonCategorias" :style="[mostrarCategoria === 'abuelos' ? { 'background-color': '#25274F' } : '']"> Abuelos </button>
    </div>
    <div v-else>
      <button @click="elegirCategoria('niños')" class="buttonCategorias" :style="[mostrarCategoria === 'niños' ? { 'background-color': '#25274F' } : '']"> Children </button>
      <button @click="elegirCategoria('adultos')" class="buttonCategorias" :style="[mostrarCategoria === 'adultos' ? { 'background-color': '#25274F' } : '']"> Adults </button>
      <button @click="elegirCategoria('abuelos')" class="buttonCategorias" :style="[mostrarCategoria === 'abuelos' ? { 'background-color': '#25274F' } : '']"> Grandparents </button>
    </div>

    <!-- Lista de relatos de la catagoría seleccionada -->
    <div v-if="mostrarCategoria" class="relatosContainer" id="relatosContainer">
      <div v-for="relato, numero in listaDeRelatos[mostrarCategoria]" :key="relato.id" class="relato">
        <router-link v-if="listaDeRelatosDisponibles.includes(relato.Titulo)" :to="{ name: 'relatos', params: { relato: relato.Titulo, categoria: mostrarCategoria } }">
          <h3>{{ ++numero }}. {{ relato.Titulo }} </h3>
        </router-link>

        <div v-else @click="mostrarPopup(relato.Titulo)" class="relatoNoDisponible">
          <h3>
            {{ ++numero }}. {{ relato.Titulo }} 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
            </svg>
          </h3>
        </div>

      </div>
    </div>

    <!-- Botón para volver arriba -->
    <button v-if="showButton" @click="goTop" class="scrollUpButton">&#9650;</button>

    <Popup v-if="TogglePopup" v-on:metodo="cerrarPopup" :texto="relatoSeleccionado" />

  </div>
</template>

<script>
import { db } from '@/main.js'
import { onSnapshot, collection, query } from 'firebase/firestore'
import Popup from '@/components/Popup.vue'

export default {
  components: {
    Popup
  },
  methods: {
    elegirCategoria (categoria) {
      if (this.mostrarCategoria === categoria) {
        this.mostrarCategoria = false
      } else {
        this.mostrarCategoria = categoria

        // Scroll al contenedor de relatos
        this.$nextTick(() => {
          document.querySelector("#relatosContainer").scrollIntoView({ behavior: 'smooth', block: 'start' })
        }) 
      }
    },
    goTop () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    handleScroll () { // Funcion para mostrar el boton de volver arriba luego de hacer scroll 500px
      if (window.scrollY > 500) {
        this.showButton = true
      } else {
        this.showButton = false
      }
    },
    playAudio () {
      try {
        const url = 'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FCumbia%20City%20-%20An%20Jone.mp3?alt=media&token=c1842d69-3c61-4bc5-8411-ce2748ee3561'
        this.audio = new Audio(url)
        this.audio.loop = true
        this.audio.currentTime = 67
        this.audio.volume = 0.05
        this.audio.play()
      } catch (e) {
        console.log(e)
      }
    },
    pauseAudio () {
      if (this.audio) {
        this.audio.pause()
      }
    },

    // Popup de relato no disponible
    mostrarPopup (tituloRelato) {
      // Cambiar el texto del popup dependiendo del idioma
      if (this.language.includes('es')) {
        this.relatoSeleccionado = tituloRelato + ' no se encuentra disponible en esta versión, <a href="mailto:support@funifelt.com?subject=Solicitud%20de%20acceso%20total%20a%20relatos%20culturales" target="_blank">contáctanos</a\> para obtener más información'
      } else {
        this.relatoSeleccionado = tituloRelato + ' is not available in this version, <a href="mailto:support@funifelt.com?subject=Request%20full%20access%20to%20spanish%20folktales" target="_blank">contact us</a\> for more information'
      }

      this.TogglePopup = true
    },
    cerrarPopup () {
      this.TogglePopup = false
    }
  },
  data () {
    return {
      language: navigator.language,
      listaDeRelatos: {
        niños: [],
        adultos: [],
        abuelos: []
      },
      mostrarCategoria: false,
      showButton: false,

      // Lista de relatos disponibles
      listaDeRelatosDisponibles: ['Amelia y Rocky', 'Arremedar al Silbón', 'Bus y Perros'],

      // Popup de relato no disponible
      TogglePopup: false,
      relatoSeleccionado: '',
    }
  },
  mounted () {
    // Cambiar titulo de la ventana
    if (this.language.includes('es')) {
      document.title = 'Categorías'
    } else {
      document.title = 'Categories'
    }

    // Reproducir musica de fondo
    this.playAudio()

    // Consultar todos los relatos de cada una de las categorias
    for (let categoria in this.listaDeRelatos) {       
      let colleccionDeRelatos = collection(db, categoria.charAt(0).toUpperCase() + categoria.slice(1))
      let consulta = query(colleccionDeRelatos)
      onSnapshot(consulta, (queryData) => {
        queryData.forEach((doc) => {
          this.listaDeRelatos[categoria].push(doc.data())
        })
      })
    }

    // Listener de scroll
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted () {
    // Pausar musica de fondo
    this.pauseAudio()
  }
}
</script>

<style src="@/assets/css/categorias.css" scoped></style>
